
import styled from 'styled-components';
import Colors from 'constants/Colors';

export const FileContainer = styled.div`
margin-top: 20px;
border: 1px solid ${Colors.PRIMARY1};
background: #fff;
margin-bottom: 40px;
resize: both;
`;

export const FileContent = styled.div`
 display:flex;
 position: relative;
 overflow: hidden;
 overflow-x: scroll; 
 min-width: 210mm;
 width: 100%;
 height: 297mm;
`;

export const File = styled.div`
width: 100%; 
top: 0;
 left: 0;
`;

export const FileHeader = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
text-transform: uppercase;
font-weight:bold;
font-size: 14px;
padding:10px;
background-color:${Colors.PRIMARY1};
color:${Colors.WHITE};
`;

export const TitleContainer = styled.div`
display: flex;
width: 50%;
justify-content: space-between;
align-items: center;

`;

export const Actions = styled.div`
display:flex;
justify-content:space-evenly;
background-color:transparent;
min-width:60px;
`;

export const ContPages = styled.div`
display:flex;
justify-content:space-evenly;
align-items: center;
background-color:transparent;
`;

export const DocumentName = styled.div`
overflow-wrap: break-word;
min-width: 90%
`;
